import React, { useState, useEffect } from "react";
import "./Sidebar.scss";
import { Link } from "react-router-dom";
import Image from "../../../components/image/Image";
import { AppIcons } from "../../../data/appIcons";
import { Menu } from "../menu/Menu";
import { getAuthProps } from "../../../lib/authenticationLibrary";


const Sidebar = (props) => {
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [role, setRoleId] = useState(0);

  const handleClick = (menu) => {
    if (selectedMenu === menu) {
      setSelectedMenu(null); // Remove class if same menu clicked again
    } else {
      setSelectedMenu(menu); // Add class to the clicked menu
    }
  };

  useEffect(() => {
    let cookie = getAuthProps();
    const roleId = cookie && cookie.roleId ? Number(cookie.roleId) : 0;
    if (roleId > 0) {
      setRoleId(roleId);
    }
  }, []);

  return (
    <>
      <div className="sidebar-section">
        <nav className="sidebar no-scrollbar">
          <div className="main-menus">
            <button className="sidebar-toggler" type="button">
              <span className="sidebar-toggler-icon"></span>
            </button>{" "}
            <Link className="sidebar-brand">
              <Image
                imagePath={AppIcons.logoImage}
                imgCustomClassName="open-bar"
                altText="Icon"
              ></Image>
            </Link>
            <div className="sidebar-menu ">
              <ul className="sidebar-menu-list">
                {Menu.map((menuItem, index) => {
                  const isAuthenticated = menuItem?.roles.includes(role)
                  return isAuthenticated && <li
                    key={index}
                    className={
                      selectedMenu === menuItem.id
                        ? "menu-item active-menu"
                        : "menu-item"
                    }
                    onClick={() => handleClick(menuItem.id)}
                  >
                    <Link to={menuItem.to} className={menuItem.subMenu ? "menu-arrow" : ""}>
                      <i className={menuItem.iconClass}></i>
                      <span>{menuItem.name}</span>
                    </Link>
                    {menuItem.subMenu ? (
                      <>
                        <ul className="sidebar-dropdown">
                          {menuItem.children.map((subMenu, index) => (
                            <li className="dropdown-menus" key={index}>
                              <Link to={subMenu.to}>{subMenu.submenuName}</Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : null}
                  </li>
                })}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
